
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 14","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"currentColor","stroke-width":"1.5","fill":"none","fill-rule":"evenodd","opacity":".7","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M4.125 3.75a.375.375 0 110 .75.375.375 0 010-.75M16.875 9a.375.375 0 110 .75.375.375 0 010-.75"}}),_c('path',{attrs:{"d":"M2.25.75h16.5a1.5 1.5 0 011.5 1.5v9a1.5 1.5 0 01-1.5 1.5H2.25a1.5 1.5 0 01-1.5-1.5v-9a1.5 1.5 0 011.5-1.5z"}}),_c('path',{attrs:{"d":"M10.5 3.75a3 3 0 110 6 3 3 0 010-6z"}})])])
          )
        }
      }
    